/**
 * «Выберите имя:» — frame 7.3.
 *
 * A plate at y77.3% carrying the label, the name and a pencil, over a warning
 * in the top-positioned dialogue frame: Russian declension will not follow a
 * name the player invents, and the board says so rather than pretending
 * otherwise.
 *
 * The plate is the same painting the choice options use, because on the board
 * it is the same painting — this screen is a choice with one option whose
 * answer happens to be text.
 */
import { useState } from 'react';

export function NameEntry({
  prompt,
  note,
  value,
  maxLength,
  onSubmit,
}: {
  prompt: string;
  note?: string | undefined;
  value: string;
  maxLength: number;
  onSubmit: (name: string) => void;
}) {
  const [draft, setDraft] = useState(value);
  const [editing, setEditing] = useState(false);

  const commit = () => {
    setEditing(false);
    onSubmit(draft.trim() || value);
  };

  return (
    <div className="naming" role="group" aria-label={prompt}>
      {note && (
        <div className="naming-note">
          <p>{note}</p>
        </div>
      )}

      <div className="naming-plate">
        <span className="naming-label">{prompt}</span>
        {editing ? (
          <input
            className="naming-field"
            value={draft}
            autoFocus
            maxLength={maxLength}
            onChange={(e) => setDraft(e.target.value)}
            onBlur={commit}
            onKeyDown={(e) => { if (e.key === 'Enter') commit(); }}
            aria-label={prompt}
          />
        ) : (
          <button className="naming-value" onClick={() => setEditing(true)}>
            <span>{draft}</span>
            <span className="naming-pencil" aria-hidden="true" />
          </button>
        )}
      </div>

      {/*
        * Confirming is a second, separate press. The board draws no button for
        * it, but a screen you can only leave by editing a field you may not
        * want to change is a screen with no way out.
        */}
      {!editing && <button className="naming-go" onClick={commit}>Дальше</button>}
    </div>
  );
}
